namespace Solovis.Reports.DataPacks {

    export class DataPackSelectorDialog {

        private _refreshingDiv;
        private _dialog: Solovis.UI.Dialog;

        private _gridInstance: DevExpress.ui.dxDataGrid;
        private _tableDiv;

        private _gridDataStore: DevExpress.data.ArrayStore;


        constructor() {
        }

        public show() {

            if (this._dialog) {
                // dialog has already been shown.
                return;
            }

            let dialogDiv = $("<div>");
            this._refreshingDiv = $("<div>").css("display", "none").appendTo(dialogDiv);

            let tableDiv = $("<div>").css("display", "none").appendTo(dialogDiv);
            this._tableDiv = tableDiv;

            this._gridDataStore = new DevExpress.data.ArrayStore({
                key: 'mountCode',
                data: []
            }); 

            let desiredWidth = Math.min($(window).width() * 0.9, 1200);
            let desiredHeight = Math.min($(window).height() * 0.9, 400);

            let dataGrid = ($(tableDiv) as any).dxDataGrid({
                dataSource: {
                    store: this._gridDataStore                    
                },

                width: desiredWidth,
                height: desiredHeight,

                allowColumnResizing: true,
                allowColumnReordering: true,
                rowAlternationEnabled: true,
                columnChooser: { enabled: true },
                columnFixing: { enabled: true },
                columnResizingMode: "widget",
                paging: { enabled: false },

                columns:
                    [
                        {
                            dataField: 'mountCode',
                            dataType: 'string',
                            caption: "Mount Code",
                            allowSorting: true,
                            width: 200,
                            fixed: true,
                            cellTemplate: (container, options) => {
                                let data = options.data;

                                if (data.liveDb) {
                                    $(container).text(data.label);
                                }
                                else {
                                    let mountLink = $("<a>").text(data.label);

                                    Solovis.UI.PopupLinkPanel.onElementClick(
                                        mountLink,
                                        (e) => {
                                            let links: Solovis.UI.PopupLinkPanelLink[] = [
                                                {
                                                    label: "Data Pack Details",
                                                    click: () => {
                                                        let detailDialog = new DataPackDetailDialog({
                                                            mountCode: data.mountCode
                                                        });
                                                        detailDialog.show();
                                                    }
                                                }
                                            ];

                                            if (data.allowUserRefresh) {
                                                links.push({ separator: true });

                                                links.push({
                                                    label: "Request Reload",

                                                    click: () => {
                                                        this._showRequestRefreshInterface(data);                                                        
                                                    }
                                                });
                                            }

                                            Solovis.UI.PopupLinkPanel.showLinks({
                                                links: links,
                                                offset: e
                                            });
                                        });

                                    $(container).append(mountLink);
                                }
                            },
                        },

                        {
                            caption: "Actions",
                            allowSorting: true,
                            width: 200,
                            fixed: true,
                            cellTemplate: (container, options) => {
                                let data = options.data;

                                let entryDiv = $("<div>");
                                $("<span>").text("Set for ").appendTo(entryDiv);
                                $("<a>").text("session").appendTo(entryDiv)
                                    .click(() => {
                                        DataPackSelector.setDefaultMountCodeForSession(data.mountCode);
                                        this._dialog.close();
                                    });
                                $("<span>").text(", ").appendTo(entryDiv);
                                $("<a>").text("browser").appendTo(entryDiv)
                                    .click(() => {
                                        DataPackSelector.setDefaultMountCodeForLocalBrowser(data.mountCode);
                                        this._dialog.close();
                                    });

                                $(container).append(entryDiv);
                            },
                        },

                        {
                            dataField: 'status',
                            dataType: 'string',
                            caption: "Status",
                            allowSorting: true,
                            width: 300
                        }
                    ]
            });

            this._gridInstance = dataGrid.dxDataGrid("instance");

            this._refreshItems();

            let resizeDataGrid = () => {
                let height = this._dialog.getAvailableContentHeight();
                let width = this._dialog.getAvailableContentWidth();

                this._gridInstance.option("width", width);
                this._gridInstance.option("height", height);
            };
            
            this._dialog = new Solovis.UI.Dialog({
                container: dialogDiv,

                title: "Select Data Pack",

                autoOpen: true,
                destroyOnClose: true,

                width: 800,
                height: 500,
                center: true,

                actions: ["Close"],

                close: () => {
                    this._dialog = null;
                    this._refreshingDiv = null;
                },

                buttons: [
                    {
                        label: "Refresh",
                        click: () => {
                            this._refreshItems();
                        }
                    },
                    {
                        label: "Cancel",
                        click: () => {
                            this._dialog.close();                          
                        }
                    }
                ],

                activate: function () {
                    resizeDataGrid();
                },

                resize: function () {
                    resizeDataGrid();
                }
            });            
        }


        public static showRequestRefreshInterface(entryData: {
            mountCode?: string
        }) {
            Solovis.UI.confirm(
                "This will attempt to initiate reload of data pack (which could take a while). If the data pack is already in process of reloading, this will have no effect.",
                "Reload Data Pack",
                (confirmed) => {
                    if (confirmed) {
                        Solovis.Rpc.invoke(
                            "~/Rpc/DataSource/TryRefreshDataPack",
                            { mountCode: entryData.mountCode });
                    }
                });
        }

        private _showRequestRefreshInterface(entryData) {
            DataPackSelectorDialog.showRequestRefreshInterface(entryData);
        }

        private async _refreshItems(): Promise<void> {
            if (!this._refreshingDiv) {
                return;
            }

            this._tableDiv.toggle(false);
            this._refreshingDiv.toggle(true);
            this._refreshingDiv.html("");
            this._refreshingDiv.text("Reloading available data pack information.");

            try {
                await DataPackTracker.getInstance().refreshDataPackMountsAsync();
            }
            finally {
                this._refreshingDiv.toggle(false);
                this._tableDiv.toggle(true);
            }

            let mountData = DataPackTracker.getInstance().getLatestMountData();

            let mountInfoList = [];

            let currentDefaultMountCode = Solovis.Reports.DataPacks.DataPackSelector.getDefaultMountCode();

            mountInfoList.push({
                mountCode: null,
                label: (!currentDefaultMountCode ? "* " : "") + "None (use live database)",
                liveDb: true
            });            

            if (mountData && mountData.byMountCodeList) {
                for (let entry of mountData.byMountCodeList) {
                    let mountInfo: any = {
                        mountCode: entry.mountCode
                    };

                    let label = "";
                    if (entry.mountCode == currentDefaultMountCode) {
                        label += "* ";
                    }
                   
                    label += entry.mountCode;                    

                    mountInfo.label = label;

                    let nodeCount = 0;
                    let nodeLoadPendingCount = 0;
                    let nodeLoadedCount = 0;
                    if (entry.mounts) {
                        for (let mount of entry.mounts) {
                            if (mount.allowUserRefresh) {
                                mountInfo.allowUserRefresh = true;
                            }
                            if (mount.isLoadInProgress) {
                                nodeLoadPendingCount++;
                            }
                            if (!mount.notLoaded) {
                                nodeLoadedCount++;
                            }

                            nodeCount++;
                        }
                    }

                    mountInfo.nodeCount = nodeCount;                    
                    mountInfo.nodeLoadPendingCount = nodeLoadPendingCount;
                    mountInfo.nodeLoadedCount = nodeLoadedCount;

                    let status = "" + nodeLoadedCount + " / " + nodeCount + " loaded";
                    if (nodeLoadPendingCount > 0) {
                        status += "; " + nodeLoadPendingCount + " loading";
                    }

                    mountInfo.status = status;

                    mountInfoList.push(mountInfo);
                }
            }            

            this._gridDataStore = new DevExpress.data.ArrayStore({ key: 'mountCode', data: mountInfoList });
            this._gridInstance.option("dataSource", this._gridDataStore);             
        }

    }

}